import MentionsOfficialAccountPostList from './MentionsOfficialAccountPostList';

export default MentionsOfficialAccountPostList;
